const api = 'https://everest-back.valide.vc/api/v2'

export const environment = {
	api: `${api}`,
	redirects: {
		roles: {
			consumer: '/dashboard',
			public: '/',
		},
	},
	gtmReport: {
		// Usuário, senha e chave do GTM ficam no .env do back
		gtmPublicId: 'GTM-5RBT2C4',
		api: api,
	},
	env: 'hml',
	production: false,
}
